// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3qL6z","question":"Question_question__10jun","description":"Question_description__3QLx_"};